import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Typography } from 'antd';
import ControlledOptionsFieldArray from '../../../components/mobile/form-helpers/ControlledOptionsFieldArray';

const { Title, Paragraph } = Typography;

function MobileMentalHealthInfo({
  bodyStyle,
  titleStyle,
  heading,
  options,
  instruction,
  fieldName
}) {

  const { t } = useTranslation();
  const { heading: instructionHeading, paragraph, paragraph1 } = instruction;

  return (
    <Box {...bodyStyle}>
      <Box paddingBottom={20} {...titleStyle}>
        <Title level={4} className="text-center">
          {t(heading)}
        </Title>
      </Box>
      <Box marginBottom={20} padding="10px" background="#15a9e10d">
        {heading && <Title level={4} className="text-center">{t(instructionHeading)}</Title>}
        <Paragraph>
          {t(paragraph)}
        </Paragraph>
        <Paragraph>
          {t(paragraph1)}
        </Paragraph>
      </Box>
      {
        options && options.length > 0 && (
          <ControlledOptionsFieldArray
            fieldName={fieldName}
            options={options}
            isMultiSelect={false}
            isDisabled
          />
        )
      }
    </Box>
  );
}

MobileMentalHealthInfo.defaultProps = {
  bodyStyle: {},
  titleStyle: {},
  instruction: {},
  options: [],
  heading: "",
  fieldName: ""
};

const { shape, string } = PropTypes;

MobileMentalHealthInfo.propTypes = {
  instruction: shape({}),
  bodyStyle: shape({}),
  titleStyle: shape({}),
  options: shape([]),
  heading: string,
  fieldName: string
};

export default MobileMentalHealthInfo;
